export default [
  "Starter",
  "Route 29 (Gras)",
  "Route 30 (Gras)",
  "Route 31 (Gras)",
  "Ruhiges Waldstück (Gras)",
  "Viola City (Geschenk: Togepi-Ei)",
  "Route 32 (Gras)",
  "Alpha-Ruinen (Gras)",
  "Falkenhorst Tunnel (Höhle)",
  "Route 33 (Gras)",
  "Azalea City (Geschenk: Shiny Gyarados-Ei in Kristall)",
  "Steineichenwald (Gras)",
  "Route 34 (Gras)",
  "Duellturm (Tausch: Elektek)",
  "Route 35 (Gras)",
  "Nationalpark (Gras)",
  "Route 36 (Gras)",
  "Route 37 (Gras)",
  "Turmruine (Innen, Nacht)",
  "Route 38 (Gras)",
  "Route 39 (Gras)",
  "Oliviana City (Angeln)",
  "Route 40 (Surfen)",
  "Route 41 (Surfen)",
  "Whirl Islands (Höhle)",
  "Anemonia City (Angeln)",
  "Route 42 (Gras)",
  "Route 43 (Gras)",
  "See des Zorns (Surfen / Shiny-Gyarados)",
  "Mahagonia City (Geschenk: Karpador)",
  "Eissturm (Höhle)",
  "Route 44 (Gras)",
  "Eispfad (Höhle)",
  "Blackthorn City (Angeln)",
  "Route 45 (Gras)",
  "Route 46 (Gras)",
  "Route 27 (Gras)",
  "Route 26 (Gras)",
  "Route 23 (Gras)",
  "Siegesstraße (Höhle)",
  "Silberberg (Innen)",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];